module.exports = __webpack_public_path__ + "img/img1.9374b189.png";